import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import PickupRequestTab from "./_components/PickupRequestTab";
import PickupLocationTab from "./_components/PickupLocationTab"; 

const PickupManagement: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Request");
  const roles = ["Request","Pickup Location"];
  return (
    <>
      <div className="p-4 space-y-4">
        <h1 className="text-3xl text-[#212121] ">Pickup Management</h1>
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={setActiveRole}
        />
        {activeRole === "Request" && <PickupRequestTab />}
        {/* {activeRole === "Assigned" && <PickupRequestTab />} */}
        {activeRole === "Pickup Location" && <PickupLocationTab />}
        {/* {activeRole === "History" && <PickupHistoryTab />} */}
      </div>
    </>
  );
};

export default PickupManagement;
